<template>
  <div>
    <div class="mb-4">
      <h2>{{$t('CONTENT.contract.card_data')}}</h2>
    </div>
    <div class="b-contract__section p-6 pb-8">
      <div class="row px-0" >
        <div class="col-2">
          <label for="number">{{$t('CONTENT.contract.contract_number')}}:<span class="b-form__required"> *</span></label>
          <input
            data-cy="contract-number"
            type="text"
            id="number"
            class="b-input"
            name="number"
            required
            v-model.lazy="number"
            v-bind:class="{ 'b-form__field-error': isFieldWithError('number', number) }"
          />
        </div>
        <div class="col-2">
          <label>{{$t('CONTENT.contract.contract_date')}}:<span class="b-form__required"> *</span></label>
          <datepicker
            :required="true"
            v-bind:class="{ 'b-datepicker__error': isFieldWithError('date', date) }"
            class="b-datepicker"
            v-model="date"
            :formatter="datepickerFormat"/>
        </div>
        <div class="col-2">
          <label for="externalId">{{$t('CONTENT.external_id')}}:</label>
          <input
            data-cy="contract-externalId"
            type="text"
            id="externalId"
            class="b-input"
            name="externalId"
            v-model.lazy="externalId"/>
        </div>
        <div class="col-3">
          <label>{{$t('CONTENT.createDate')}}:</label>
          <datepicker
            :required="false"
            class="b-datepicker"
            v-model="createDate"
            :formatter="datepickerFormat"/>
        </div>
      </div>
      <div class="row mt-5 px-0 b-form__row_type_flex-end">
        <div class="col-5">
          <div class="b-form__container" >
            <label>{{$t('CONTENT.contract.lessee')}}:<span class="b-form__required"> *</span></label>
            <cool-select :list="counterparties"
                         option-value="id"
                         option-text="value"
                         v-model="currentLessee"
                         :placeholder="$t('CONTENT.choose')"
                         :isError="isFieldWithError('currentLessee', currentLessee)"/>
          </div>
        </div>
        <div class="pr-1">
          <button
            type="button"
            :data-cy="`add-counterparty-lessee`"
            class="b-btn b-btn_type_add"
            @click="openCounterPartyDialog">
            <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
          </button>
        </div>
        <button
          type="button"
          :data-cy="`import-counterparty-lessee`"
          class="b-btn b-btn_type_add"
          @click="openImportDialog">
          <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="xls"></dynamic-icon>
        </button>
        <div class="b-contract__check mx-2 mb-2" v-if="checkIsCounterpartyIntragroup(currentLessee)">
          <dynamic-icon class="mr-2" icon="check"></dynamic-icon>
          {{$t('CONTENT.counterparty.VGO')}}
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-3">
          <div class="b-form__container">
            <label>{{$t('CONTENT.contract.lessor')}}:<span class="b-form__required"> *</span></label>
          </div>
        </div>
      </div>
      <div :key="counter" class="b-contracts__lessor-wrap">
        <div v-for="(item, index) in lessorsIds" class="b-contracts__lessor-item">
          <LessorRow
            :lessorIndex="index"
            :lessor="item"
            :delete-disabled="lessorsIds.length === 1 || deleteLessorDisabled"
            :select-disabled="deleteLessorDisabled"
            :isError="lessorsIds && lessorsIds.length - 1 === index ? isFieldWithError('lessor', item) : false"
            @selectLessor="selectLessor"
            @setNewLessor="setNewLessor"
            @openImportDialog="openImportDialog"
            :hiddenLessorIds="lessorsIds"/>
        </div>
      </div>
      <div class="row mt-4 mb-5">
        <div class="col-4">
          <div class="b-form__container">
            <button type="button" class="b-btn" @click="addLessor" data-cy="add-lessor" :disabled="isDisabledAddLessor || deleteLessorDisabled">
              <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
              {{$t('CONTENT.contract.add_lessor')}}
            </button>
          </div>
        </div>
      </div>
      <div class="row mb-5 b-form__row_type_flex-end">
        <div class="col-2">
          <div class="b-form__container">
            <label>{{$t('CONTENT.contract.turnover_percentage')}}:</label>
            <numeric class="b-numeric" controls :min="0" :max="100" v-model="turnoverPercentage"></numeric>
          </div>
        </div>
        <div class="col-2">
          <div class="b-form__container">
            <label>{{$t('CONTENT.contract.revenues')}}:</label>
            <numeric class="b-numeric" controls :min="0" v-model="revenues"></numeric>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <label for="commentary">{{$t('CONTENT.comment')}}:</label>
          <textarea
            data-cy="contract-commentary"
            type="text"
            id="commentary"
            class="b-textarea"
            name="commentary"
            v-model.lazy="commentary"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <label for="responsible">{{$t('CONTENT.contract.initiator')}}:<span class="b-form__required"> </span></label>
          <input
            data-cy="responsible"
            type="text"
            id="responsible"
            class="b-input"
            name="responsible"
            v-model.lazy="responsible"
          />
        </div>
      </div><div class="row">
      <div class="col-6">
        <label for="responsible">{{$t('CONTENT.contract.prolongation_type')}}:<span class="b-form__required"> </span></label>
        <input
          data-cy="responsible"
          type="text"
          id="responsible"
          class="b-input"
          name="responsible"
          v-model.lazy="prolongationType"
        />
      </div>
    </div>
      <popup name="lessee-counterparty-popup" height="auto" :scrollable="true">
        <server-error :error="error"/>
        <GeneralForm
          v-if="isCounterPartyShow"
          :counterparty="counterpartyForForm"
          :counterpartyVatHistoryList="counterpartyVatHistoryList"
          @createNewCounterparty="onCreateCounterparty"
          @openVatSettings="openVatSettings"
          @close="closeCounterPartyDialog"
        />
      </popup>
      <popup name="vat-settings-lessee-popup" height="auto" :scrollable="true">
        <VatSettingsForm
          v-if="isVatSettingsOpen"
          :rates="counterpartyVatHistoryList"
          :counterparty-type-id="counterpartyForForm ? counterpartyForForm.idInDB : null"
          :is-create="!counterpartyForForm || !counterpartyForForm.idInDB"
          @close="closeVatSettings"
          @saveVatRates="updateVatRates"
        />
      </popup>
      <popup name="counterparty-import-popup" height="auto" :scrollable="true">
        <ImportDialogWidget :importType="'counterparty'" v-if="isShowImportDialog" @close="closeImportDialog"></ImportDialogWidget>
      </popup>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import GeneralForm from "../../../directories/counterparty/edit/GeneralForm";
import VatSettingsForm from "../../../directories/counterparty/edit/VatSettingsForm";
import ImportDialogWidget from "../../../widgets/ImportDialogWidget";
import dateConverter from "../../../../utils/converters/date.converter";
import LessorRow from "./LessorRow";
import datepickerFormat from '../../../../mixins/datepickerFormat.mixin';

export default {
  components: {
    LessorRow,
    GeneralForm,
    VatSettingsForm,
    ImportDialogWidget
  },
  mixins: [datepickerFormat],
  props: {
    formData: {
      type: Object
    },
    validationErrors: {
      type: Array
    },
    deleteLessorDisabled: {
      type: Boolean
    }
  },
  data() {
    return {
      error: null,
      counter: 0,
      parentObjectName: "contract",
      isCounterPartyShow: false,
      isCounterPartyForLessorShow: false,
      counterpartyForForm: null,
      isVatSettingsOpen: false,
      counterpartyVatHistoryList: [],
      isShowImportDialog: false,
      isDisabledAddLessor: true
    };
  },
  computed: {
    ...mapGetters(["getContractSettings"]),
    ...mapGetters(["getCounterpartiresForContract"]),
    ...mapGetters(["getLessors"]),
    ...mapGetters(["allCounterparties"]),
    lessors() {
      return this.getLessors;
    },
    number: {
      get() {
        return this.formData.contract.number;
      },
      set(newVal) {
        this.$store.commit("EDIT_VALUE", {
          parent: this.parentObjectName,
          name: "number",
          value: newVal,
        });
      },
    },
    responsible: {
      get() {
        return this.formData.contract.responsible;
      },
      set(newVal) {
        this.$store.commit("EDIT_VALUE", {
          parent: this.parentObjectName,
          name: "responsible",
          value: newVal
        });
      }
    },
    prolongationType: {
      get() {
        return this.formData.contract.prolongationType;
      },
      set(newVal) {
        this.$store.commit("EDIT_VALUE", {
          parent: this.parentObjectName,
          name: "prolongationType",
          value: newVal
        });
      }
    },
    externalId: {
      get() {
        return this.formData.contract.externalId;
      },
      set(newVal) {
        this.$store.commit("EDIT_VALUE", {
          parent: this.parentObjectName,
          name: "externalId",
          value: newVal
        });
      }
    },
    turnoverPercentage: {
      get() {
        if (this.formData.contract.turnoverPercentage !== null) {
          return this.formData.contract.turnoverPercentage;
        }
      },
      set(newVal) {
        this.$store.commit("EDIT_VALUE", {
          parent: this.parentObjectName,
          name: "turnoverPercentage",
          value: newVal
        });
      }
    },
    revenues: {
      get() {
        if (this.formData.contract.revenues !== null) {
          return this.formData.contract.revenues;
        }
      },
      set(newVal) {
        this.$store.commit("EDIT_VALUE", {
          parent: this.parentObjectName,
          name: "revenues",
          value: newVal
        });
      }
    },
    commentary: {
      get() {
        return this.formData.contract.commentary;
      },
      set(newVal) {
        this.$store.commit("EDIT_VALUE", {
          parent: this.parentObjectName,
          name: "commentary",
          value: newVal
        });
      }
    },
    date: {
      get() {
        if (this.formData.contract.date !== null) {
          return dateConverter.convertToDate(this.formData.contract.date);
        } else {
          return null;
        }
      },
      set(newVal) {
        if (newVal !== null) {
          const dateInStringFormat = dateConverter.convertToString(newVal);
          this.$store.commit("EDIT_VALUE", {
            parent: this.parentObjectName,
            name: "date",
            value: dateInStringFormat,
          });
        } else {
          this.formData.contract.date = null;
        }
      },
    },
    createDate: {
      get() {
        if (this.formData.contract.createDate !== null) {
          return dateConverter.convertToDate(this.formData.contract.createDate);
        } else
        {
          return null;
        }
      },
      set(newVal) {
        if (newVal !== null) {
          const dateInStringFormat = dateConverter.convertToString(newVal);
          this.$store.commit("EDIT_VALUE", {
            parent: this.parentObjectName,
            name: "createDate",
            value: dateInStringFormat,
          });
        } else {
          this.formData.contract.createDate = null;
        }
      },
    },
    lessorsIds: {
      get() {
        if (this.getLessors.length === 0) {
          return this.lessorsIds = [''];
        } else {
          if(this.getLessors[this.getLessors.length - 1] === '') {
            this.isDisabledAddLessor = true;
          }

          return this.getLessors;
        }
      }, set() {}
    },
    counterparties() {
      return this.getCounterpartiresForContract;
    },
    currentLessee: {
      get() {
        if(this.formData.contract.lesseeCounterpartyId === null) {
          this.$store.commit("EDIT_VALUE", {
            parent: this.parentObjectName,
            name: "lesseeCounterpartyId",
            value: this.getContractSettings.systemOwnerCounterpartyId
          });
          return this.getContractSettings.systemOwnerCounterpartyId;
        } else {
          return this.formData.contract.lesseeCounterpartyId;
        }
      },
      set(newVal) {
        this.$store.commit("EDIT_VALUE", {
          parent: this.parentObjectName,
          name: "lesseeCounterpartyId",
          value: +newVal
        });
      }
    },
  },
  methods: {
    addLessor() {
      this.$store.commit('ADD_LESSOR');
    },
    async onCreateCounterparty(index) {
      this.setNewCounterparty(index);
    },
    async setNewCounterparty() {
      await this.$store.dispatch('getAllCounterparties');

      this.$store.commit("EDIT_VALUE", {
        parent: this.parentObjectName,
        name: "lesseeCounterpartyId",
        value: this.getCounterpartiresForContract[0].id
      });
    },
    setNewLessor(index) {
      this.lessorsIds[index] = this.getCounterpartiresForContract[0].id;
    },
    selectLessor(index, item) {
      this.isDisabledAddLessor = false;
      this.lessorsIds[index] = item;
      this.$eventBus.$emit('addNewLessor', this.lessorsIds[index]);
    },
    openCounterPartyDialog() {
      this.counterpartyVatHistoryList = [];
      this.isCounterPartyShow = true;
      this.$modal.show('lessee-counterparty-popup');
    },
    closeCounterPartyDialog() {
      this.isCounterPartyShow = false;
      this.counterpartyForForm = null;
      this.$modal.hide('lessee-counterparty-popup');
    },
    openVatSettings() {
      this.isVatSettingsOpen = true;
      this.$modal.show('vat-settings-lessee-popup');
    },
    closeVatSettings() {
      this.isVatSettingsOpen = false;
      this.$modal.hide('vat-settings-lessee-popup');
    },
    updateVatRates(rates) {
      this.counterpartyVatHistoryList = rates;
    },
    openImportDialog() {
      this.isShowImportDialog = true;
      this.$modal.show('counterparty-import-popup');
    },
    async closeImportDialog() {
      await this.$store.dispatch('getAllCounterparties');
      this.isShowImportDialog = false;
      this.$modal.hide('counterparty-import-popup');
    },
    checkIsCounterpartyIntragroup(counterpartyId) {
      for (let i = 0; i < this.allCounterparties.length; i++) {
        if (this.allCounterparties[i].idInDB === counterpartyId) {
          return this.allCounterparties[i].isIntragroupTurnover;
        }
      }
    },
    isFieldWithError(field, value) {
      return !value && this.validationErrors && this.validationErrors.includes(field);
    },
  }
};
</script>
